export type ServerStatusReq = {};

export type ServerStatusResponse = {
  serverStatus: ServerStatus;
};

/**
 * @swagger
 *  components:
 *    schemas:
 *      ServerStatus:
 *        type: object
 *        required: [ "allOk" ]
 *        properties:
 *          allOk:
 *            type: boolean
 *            description: If everyhing is ok
 *          functionVersion:
 *            type: string
 *            description: Version of functions
 *          apiVersion:
 *            type: string
 *            description: Version of API
 *          environment:
 *            type: string
 *            description: Current environment (e.g. DEV, PROD, LOCAL)
 *        example:
 *          allOk: true
 *          functionVersion: "1.0.2"
 *          apiVersion: "1.0.1"
 *          isEmulator: true
 *          environment: "DEV"
 */
export type ServerStatus = {
  allOk: boolean;
  functionVersion: string;
  apiVersion: string;
  isEmulator: boolean;
  environment: string;
};
